import { CATEGORIES, SEVERITY_BG } from "../lib/diseases";

// Periodic-table-style disease grid:
//   Left "stub" column shows the category number + icon (like row labels).
//   Each row contains the diseases of that category, in fixed slots.
//   Click a cell to open the detail dialog. Dimmed cells are filtered out.
export const DiseaseGrid = ({ diseases, onSelect, highlight }) => {
  return (
    <div className="w-full overflow-x-auto pb-4" data-testid="disease-grid">
      <div className="min-w-[1100px] space-y-1">
        {CATEGORIES.map((cat) => {
          const rowDiseases = diseases.filter((d) => d.cat === cat.id);
          const Icon = cat.icon;
          return (
            <div
              key={cat.id}
              className="grid gap-1"
              style={{ gridTemplateColumns: "120px repeat(8, minmax(0, 1fr))" }}
              data-testid={`disease-row-${cat.id}`}
            >
              {/* Row label cell */}
              <div
                className={`${cat.tone} border-2 border-zinc-950 px-3 py-2 flex flex-col justify-between text-left`}
              >
                <div className="flex items-center justify-between font-mono text-[10px] tracking-[0.2em] font-bold">
                  <span>{cat.n}</span>
                  <Icon size={12} strokeWidth={2.75} />
                </div>
                <div className="font-heading font-black text-sm leading-none tracking-tight uppercase">
                  {cat.short}
                </div>
                <div className="font-mono text-[9px] uppercase tracking-[0.15em] opacity-80">
                  {rowDiseases.length} {rowDiseases.length === 1 ? "disease" : "diseases"}
                </div>
              </div>

              {/* Disease cells */}
              {rowDiseases.map((d, idx) => {
                const isDimmed = highlight && !highlight(d);
                const sevCls = SEVERITY_BG[d.severity] || "bg-zinc-200 text-black";
                return (
                  <button
                    key={d.id}
                    data-testid={`disease-cell-${d.id}`}
                    onClick={() => onSelect(d)}
                    style={{ animationDelay: `${Math.min(idx * 24, 280)}ms` }}
                    className={`pt-cell aspect-[1.15/1] relative border-2 border-zinc-950 ${cat.tone} ${
                      isDimmed ? "opacity-20 grayscale" : "opacity-100"
                    } hover:z-10 hover:neo-shadow hover:-translate-y-0.5 transition-all duration-150 group flex flex-col justify-between p-2 text-left`}
                  >
                    <div className="flex items-start justify-between text-[9px] font-mono leading-none">
                      <span className="font-bold">{cat.n}</span>
                      <span
                        className={`${sevCls} border border-zinc-950 px-1 py-0.5 text-[8px] tracking-wider font-bold`}
                      >
                        {d.severity === "extreme"
                          ? "!!!"
                          : d.severity === "high"
                          ? "!!"
                          : d.severity === "warning"
                          ? "!"
                          : "·"}
                      </span>
                    </div>
                    <div className="font-heading font-black text-2xl lg:text-3xl text-center leading-none tracking-tighter">
                      {d.code}
                    </div>
                    <div className="font-mono text-[8px] leading-tight text-center uppercase tracking-wider line-clamp-2">
                      {d.name}
                    </div>
                  </button>
                );
              })}

              {/* Empty placeholder cells for visual alignment */}
              {Array.from({ length: Math.max(0, 8 - rowDiseases.length) }).map((_, i) => (
                <div
                  key={`empty-${cat.id}-${i}`}
                  className="aspect-[1.15/1] border-2 border-dashed border-zinc-200 bg-white/40"
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
